/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StepCountUpBigWinController} from "@nolimitcity/slot-game/bin/game/winpresentation/bigwin/stepcountup/StepCountUpBigWinController";
import {Timeline} from "gsap";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";
import {WildNudgeBigWinView} from "./WildNudgeBigWinView";

export class WildNudgeBigWinController extends StepCountUpBigWinController {

    private _wnView:WildNudgeBigWinView;

    constructor(indexes:[number, number]) {
        super(indexes, {
            skipLastLevelCountUpIfSmall : false
        });

        this._wnView = new WildNudgeBigWinView();
    }

    protected getBigWinLevelAnimation(level:number):Timeline {
        return this._wnView.getBigWinLevelAnimation(level, this._winRatios[level]);
    }

    protected playEndingAnimation(isAborted:boolean):void {
        this._wnView.playEndingAnimation(this._gameData!.singleWin, this._winRatios[this._winLevel], isAborted);
        SlotGame.sound.playEffect((<any>WildNudgeSoundConfig.instance)[`BIG_WIN_END_${this._winLevel}`]);
        SlotGame.winFieldController.showWinField();
    }

    protected playCountUp(from:number, to:number, duration:number, preTotalWin:number = 0):Timeline | null {
        return this._wnView.playCountUp(from, to, duration);
    }

    protected playBigWinSound():void {
        SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.BIG_WIN);
    }

    protected stopAllSounds():void {
        SlotGame.sound.stopEffect(WildNudgeSoundConfig.instance.BIG_WIN);
        SlotGame.sound.fadeAmbience(1, 1000);
    }
}